<template>
  <div>
    <OnexAlert v-if="propIsShowMessage" :type="Notifications.warning" :icon="mdiAlert">
      {{
        $t('L_please_be_advised_that_an_immediate_withdrawal_of_confirmation', {
          amount: propImmediatePayAmount,
        })
      }}
      <template #description>
        <v-row wrap>
          <v-col cols="12">
            <ul class="payment-alert-list">
              <li v-if="propShowFirstMessage">
                {{ $t('L_you_have_an_outstanding_past_due') }}
              </li>
              <li v-if="propShowSecondMessage">
                {{ $t('L_you_have_selected_a_withdrawal_day') }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </template>
    </OnexAlert>
    <div class="mb-4 pb-4">
      <v-row wrap class="mb-4">
        <v-col cols="12">
          <div>
            <v-row wrap class="text-center mt-4">
              <v-col cols="12" text-center>
                <v-row wrap class="ml-4">
                  <v-col cols="12" font-size--16 font-weight-bold>
                    <v-icon color="success" :icon="mdiCheckCircle" />
                    <span class="font-weight-bold font-size--16">&nbsp;{{ $t('L_success') }}</span>
                  </v-col>
                </v-row>
                <div class="maxWidth600">
                  <v-row wrap class="text-left">
                    <v-col cols="12" class="font-size--16 mt-4 mb-4 ml-4 mr-4">
                      <span
                        v-html="
                          $t('L_your_billing_information_has_been_successfully_updated', {
                            policy: getPolicyNum,
                          })
                        "
                      />
                    </v-col>
                    <v-card class="mt-4 setmarginauto">
                      <div class="maxWidth480 mt-4 mb-4 ml-4 mr-4">
                        <v-row wrap>
                          <v-col cols="12" class="font-size--16 font-weight-bold ml-4 mt-4 pb-0">
                            {{ $t('L_here_are_the_details_of_your_authorization') }}
                          </v-col>
                        </v-row>
                        <v-row wrap class="ml-2 text-left pt-0 mt-0" v-if="isDirectBill">
                          <v-col cols="12" class="font-size--14 pa-0 ml-2 mt-8 pb-0">
                            {{ $t('L_billing_method') }}
                          </v-col>
                          <v-col
                            cols="12"
                            class="font-size--16 pa-0 ml-2 mb-4 font-weight-bold pt-0 pb-0"
                          >
                            {{ frequencyType }}
                          </v-col>
                          <v-col cols="12" class="font-size--14 pa-0 mt-4 ml-2 mb-0 pb-0">
                            {{ $t('L_payment_amount') }}
                          </v-col>
                          <v-col cols="12" class="font-size--16 pa-0 ml-2 mb-4 font-weight-bold">
                            {{ getPropPaymentAmount }}
                          </v-col>
                          <!-- <v-col cols="12" font-size--14 mb-2>
                          {{ $t('L_next_payment_due') }}
                        </v-col>
                        <v-col cols="12" font-size--16 font-weight-bold mb-4>
                          {{ propPaymentDueDate }}
                        </v-col> -->
                        </v-row>
                        <v-row wrap v-else text-left>
                          <v-col cols="12">
                            <v-row wrap class="ml-4 mb-4">
                              <v-col cols="12" class="font-size--14 mt-4 pb-0">
                                {{ $t('L_billing_method') }}
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-2 font-size--16 font-weight-bold pt-0 pb-0"
                              >
                                {{ frequencyType }}
                              </v-col>
                              <v-col cols="12" class="mt-4 font-size-14 pb-0">
                                {{ $t('L_payment_amount') }}
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-2 font-size--16 font-weight-bold pt-0 pb-0"
                              >
                                {{ getPropPaymentAmount }}
                              </v-col>

                              <v-col cols="12" class="font-size--14 mt-4 pb-0">
                                {{ $t('L_payment_withdrawal_date') }}
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-2 font-size--16 font-weight-bold pt-0 pb-0"
                              >
                                {{ getPaymentWithdrawalDay }}
                              </v-col>
                              <!-- <v-col cols="12" class="mt-4 font-size--14">
                              {{ $t('L_next_scheduled_withdrawal_date') }}
                            </v-col>
                            <v-col cols="12" class="mt-2 font-size--16 font-weight-bold">
                              {{ propPaymentDueDate }}
                            </v-col> -->
                              <v-col cols="12" class="font-size--14 mt-4 pb-0">
                                {{ $t('L_bank_account') }}
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-2 font-size--16 font-weight-bold pt-0 pb-0"
                              >
                                {{ getMaskedAcctNumberWAcctType }}
                              </v-col>
                              <v-col
                                cols="12"
                                class="mt-2 font-size--14 font-weight-regular pt-0 pb-0"
                              >
                                {{ getBankName }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row wrap class="setmarginauto mt-4 mb-4">
        <div class="maxWidth600">
          <v-row wrap class="text-left">
            <v-col cols="12" class="font-size--16 mt-4 mb-4">
              <span v-html="$t('L_a_confirmation_email_will_be_sent_to', { email: userEmail })" />
            </v-col>
          </v-row>
        </div>
      </v-row>
      <div>
        <v-row wrap class="justify-center">
          <v-col cols="12" sm="5" class="mt-4 mb-4" :class="$vuetify.display.smAndUp ? 'mr-4' : ''">
            <div class="maxwidthButton mx-auto">
              <v-btn block class="maxwidthButton centeredBtn" color="primary" @click="goToStepSix">
                {{ $t('L_done') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapActions } from 'pinia';
import { currency } from '@/shared/util/formatters';
import MessageDialog from '../../../../../components/MessageDialog.vue';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mdiAlert, mdiCheckCircle } from '@mdi/js';
import { Notifications, OnexAlert } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'BankAccountTypeChangeStepFive',
  components: {
    MessageDialog,
    OnexAlert,
  },
  data: () => ({
    processCompleted: false,
    mdiCheckCircle,
    mdiAlert,
    Notifications,
  }),
  props: {
    selectedOption: {
      type: String,
      required: false,
      default: '-1',
    },
    bankInfo: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    propImmediatePayAmount: {
      type: String,
      required: false,
      default: '',
    },
    propPaymentAmount: {
      type: String,
      required: false,
      default: '',
    },
    propPaymentDueDate: {
      type: String,
      required: false,
      default: '',
    },
    propIsPastDueAndOnDirectBill: {
      type: Boolean,
      required: false,
      default: false,
    },
    propIsPaidToDateInFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
    propIsShowMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    propIsPastDue: {
      type: Boolean,
      required: false,
      default: false,
    },
    propShowFirstMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    propShowSecondMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      dateFormat: 'getDateFormat',
    }),
    ...mapState(usePolicyStore, {
      paymentData: 'paymentData',
      policyData: 'currentPolicy',
      showPayNowButton: 'showPayNow',
      preLoadBank: 'preLoadBank',
    }),
    getPropPaymentAmount() {
      return currency(+this.propPaymentAmount, 2);
    },
    getBillingMethod() {
      if (this.selectedOption === '1bd') {
        return this.$t('1bd');
      } else if (this.selectedOption === '1db') {
        return this.$t('1db');
      } else if (this.selectedOption === '3db') {
        return this.$t('3db');
      } else if (this.selectedOption === '6db') {
        return this.$t('6db');
      } else if (this.selectedOption === '12db') {
        return this.$t('12db');
      } else {
        return '';
      }
    },
    userEmail() {
      return this.customerProfile.email || this?.policyData?.owner?.email;
    },
    isDirectBill() {
      if (this.selectedOption !== '1bd') {
        return true;
      }
      return false;
    },
    frequencyType() {
      if (this.selectedOption === '1bd') {
        return `${this.$t('L_every_month_by_automatic_bank_withdrawal')} ${this.$t(
          'L_every_month'
        )}`;
      } else if (this.selectedOption === '1db') {
        return `${this.$t('L_monthly_direct_bill')} ${this.$t('L_every_month')}`;
      } else if (this.selectedOption === '3db') {
        return `${this.$t('L_every_three_months')} ${this.$t('L_every_three_months_sub')}`;
      } else if (this.selectedOption === '6db') {
        return `${this.$t('L_every_six_months')} ${this.$t('L_every_six_months_sub')}`;
      } else if (this.selectedOption === '12db') {
        return `${this.$t('L_once_a_year')} ${this.$t('L_once_a_year_sub')}`;
      }
      return '';
    },
    paymentAmount() {
      if (this.selectedOption === '1bd') {
        return this.policyData?.paymentInfo?.newPremiumAmount || '';
      } else if (this.selectedOption === '1db') {
        return this.policyData?.paymentInfo?.newPremiumAmount || '';
      } else if (this.selectedOption === '3db') {
        return this.policyData?.paymentInfo?.quarterlyPremium || '';
      } else if (this.selectedOption === '6db') {
        return this.policyData?.paymentInfo?.semiAnnualPremium || '';
      } else if (this.selectedOption === '12db') {
        return this.policyData?.paymentInfo?.annualPremium || '';
      }
      return '';
    },
    getPaymentWithdrawalDay() {
      const value = `${this.bankInfo?.draftDay}`;
      let num;
      const val = value.startsWith('0') ? value.slice(1) : value;
      switch (val) {
        case '1':
        case '21':
          num = 'st';
          break;
        case '2':
        case '22':
          num = 'nd';
          break;
        case '3':
        case '23':
          num = 'rd';
          break;
        default:
          num = 'th';
      }
      const datetext = `${val}${num}`;
      return this.$t('L_date_of_each_month', { day: datetext });
    },
    getMaskedAcctNumberWAcctType() {
      const value = this.bankInfo?.accountNumber || '';
      return `${value.substring(0, value.length - 4).replace(/\d/g, '')}****${value.substring(
        value.length - 4
      )} ${this.bankInfo?.accountTypeString}`;
    },
    getPolicyNum() {
      return this.policyData?.contractId || '';
    },
    getBankName() {
      return this.bankInfo?.bankName || '';
    },
    paymentDueDate() {
      return this.policyData?.data?.nextPaymentDueDate || '';
    },
    payInProgress() {
      return this.policyData?.paymentInfo?.PayInProcess === '1';
    },
    kubraPaymentInProgress() {
      // return this.policy?.kubraPaymentStatus !== null;
      return !!this.policyData?.kubraPaymentStatus;
    },
    showPayInProgressBanner() {
      return this.payInProgress || this.kubraPaymentInProgress;
    },
    currentDirectBillMonthly() {
      if (
        this.policyData?.paymentInfo?.billMode === '01' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillQuarterly() {
      if (
        this.policyData?.paymentInfo?.billMode === '03' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillSemiAnnual() {
      if (
        this.policyData?.paymentInfo?.billMode === '06' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentDirectBillAnnual() {
      if (
        this.policyData?.paymentInfo?.billMode === '12' &&
        this.policyData?.paymentInfo?.billForm.toLowerCase() === 'a1'
      ) {
        return true;
      }
      return false;
    },
    currentBankDraftMonthly() {
      if (this.policyData?.paymentInfo?.billForm.toLowerCase() === 'b2') {
        return true;
      }
      return false;
    },
    getMonthlyAmount() {
      return this.policyData?.paymentInfo?.newPremiumAmount || '';
    },
    getQuarterlyDirectBillAmount() {
      return this.policyData?.paymentInfo?.quarterlyPremium || '';
    },
    getSemiAnnualDirectBillAmount() {
      return this.policyData?.paymentInfo?.semiAnnualPremium || '';
    },
    getAnnualDirectBillAmount() {
      return this.policyData?.paymentInfo?.annualPremium || '';
    },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    goToStepSix() {
      this.$emit('done');
    },
  },
  async mounted() {
    this.processCompleted = false;
    await this.removeAlerts('payment');
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.setmarginauto {
  margin: auto;
}
.maxWidth600 {
  max-width: 600px;
  margin: auto;
}
.maxWidth480 {
  max-width: 480px;
  margin: auto;
}
.maxwidthButton {
  max-width: 280px;
}
.centeredBtn {
  margin: auto;
}
.payment-alert-list {
  list-style-type: disc;
  padding-left: 20px;
}
</style>
